export const passwordValidation = () => {
  return new RegExp(
    /^(?=.*[0-9])(?=.*[A-Z])(?=.*[_!@#$%^&*,.\\|/?";:<>[\]{}`~()'-+=])[a-zA-Z0-9_!@#$%^&*,.\\|/?";:<>[\]{}`~()'-+=]{10,}$/
  )
}
